export type OperationalEvent = {
  level: 'info' | 'warning' | 'error';
  code: string;
  message: string;
  context?: Readonly<Record<string, unknown>>;
};
export interface ObservabilityPort {
  capture(event: OperationalEvent): void;
}
const sensitive =
  /email|name|phone|token|password|secret|photo|content|memo|description|address|stack/iu;
const sensitiveValue =
  /(?:[\w.+-]+@[\w.-]+\.[A-Za-z]{2,}|https?:\/\/\S+|\b(?:bearer\s+)?[A-Za-z0-9_-]{24,}\b|\b01[016789][ -]?\d{3,4}[ -]?\d{4}\b)/giu;

function redactValue(value: unknown): unknown {
  if (typeof value === 'string') return value.replace(sensitiveValue, '[REDACTED]').slice(0, 128);
  if (Array.isArray(value)) return value.slice(0, 20).map(redactValue);
  if (value && typeof value === 'object')
    return redactContext(value as Readonly<Record<string, unknown>>);
  return value;
}

export function redactContext(context: Readonly<Record<string, unknown>> = {}) {
  return Object.fromEntries(
    Object.entries(context).map(([key, value]) => [
      key,
      sensitive.test(key) ? '[REDACTED]' : redactValue(value),
    ]),
  );
}
export class OptInBrowserObservability implements ObservabilityPort {
  constructor(
    private readonly enabled: boolean,
    private readonly sink: (event: OperationalEvent) => void = (event) =>
      console.error('[runtime]', event),
  ) {}
  capture(event: OperationalEvent) {
    if (!this.enabled) return;
    this.sink({
      ...event,
      message: String(redactValue(event.message)).slice(0, 256),
      context: redactContext(event.context),
    });
  }
}
